import React, { useState } from "react";
import { useRemovePronosticV2Mutation } from "pronosticsv2/api/pronosticv2.api";
import { useNavigate } from "react-router-dom";

export function Pronosticv2DeleteAdminView() {
  const [idToDelete, setIdToDelete] = useState("");
  const [removePronosticV2, { isLoading, isError, isSuccess, error }] =
    useRemovePronosticV2Mutation();
  const navigate = useNavigate();

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (idToDelete) {
      try {
        await removePronosticV2(idToDelete).unwrap();
        alert("PronosticV2 deleted successfully!");
        navigate("/admin/pronostics-v2"); // Navigate back to the list view
      } catch (err) {
        console.error("Failed to delete PronosticV2:", err);
        alert(`Failed to delete PronosticV2: ${JSON.stringify(error)}`);
      }
    }
  };

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Delete PronosticV2</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label
            htmlFor="pronosticId"
            className="block text-sm font-medium text-gray-700"
          >
            PronosticV2 ID:
          </label>
          <input
            type="text"
            id="pronosticId"
            value={idToDelete}
            onChange={(e) => setIdToDelete(e.target.value)}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            placeholder="Enter PronosticV2 ID"
            required
          />
        </div>
        <button
          type="submit"
          disabled={isLoading}
          className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
        >
          {isLoading ? "Deleting..." : "Delete PronosticV2"}
        </button>
      </form>
      {isSuccess && <p className="mt-4 text-green-600">Deletion successful!</p>}
      {isError && (
        <p className="mt-4 text-red-600">Error: {JSON.stringify(error)}</p>
      )}
    </div>
  );
}
